import Action from "./Action";
import Shape from "../Main/Shape.js";
import {Serialization} from "../Main/Serializer";

export default class ShapeDeleteAction implements Action {

    readonly position: number;

    constructor(readonly shape: Shape) {
        this.position = shape.shapeCollection.getShapes().indexOf(shape);

        if(this.position === -1) {
            throw new Error('Invalid position');
        }
    }

    public apply() {
        this.shape.shapeCollection.detachShape(this.shape);

        this.shape.shapeCollection.checkCloseShapesPanel();
    }

    public revert() {
        this.shape.shapeCollection.attachShape(this.shape, this.position);
    }

    public merge(newAction: Action): boolean {
        return false;
    }

    public serializeForDebug(): Serialization {
        return {
            shape: this.shape.id,
            position: this.position,
        };
    }
}
